import { useDispatch, useSelector } from 'react-redux';
import { BtnWrap, EditObstructionOptions, ModeToggle, ShapeBtn } from './style';
import ActionStrip from 'components/ModeStrip/Strip';
import { RootState } from 'store';
import { setSelectedObstructionId, toggleAddObstructionsMode, toggleDeleteObstructionsMode } from 'store/slices/ToolSlice';
import { OBS_SHAPE } from 'store/slices/ToolSlice/types';
import UndoButton from 'components/tool/Editor/AddObstructionBtn/UndoButton';

export default function EnableObstructionModeStrip(){
	const { deleteObstructionsMode, obstructionShape, selectedObstructionId, manualObs, addObstructionsMode } =
		useSelector((state: RootState) => state.toolNewPostions.data);
	const dispatch = useDispatch();
	const showAddSelection = !deleteObstructionsMode && addObstructionsMode && !selectedObstructionId;
	const enableAddObsMode = (shape: OBS_SHAPE) => {
		if (selectedObstructionId) {
			dispatch(setSelectedObstructionId({ id: null }));
		}
		dispatch(toggleAddObstructionsMode({ enable: true, shape }));
		if(deleteObstructionsMode){
			dispatch(toggleDeleteObstructionsMode({ enable: false }));
		}
	};
	const toggleDeleteObsMode = () => {
		const deleteEnabled = deleteObstructionsMode;
		dispatch(toggleDeleteObstructionsMode({ enable: !deleteEnabled }));
		if (!deleteEnabled) {
			dispatch(toggleAddObstructionsMode({ enable: false }));
		} else {
			dispatch(toggleAddObstructionsMode({ enable: true }));
		}
		dispatch(setSelectedObstructionId({ id: null }));
	};

	return (
		<ActionStrip
			action="Edit Obstructions"
			className='edit-obstructions-strip'
			icon={
				<svg 
					width='21'
					height='21'
					xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
					<path d="M15.6855 10.5784L10.1855 15.6855L9.47094 18.1867C9.34408 18.6307 9.74537 19.0456 10.1934 18.9336L13.1855 18.1855L18.1855 
					13.5702M15.6855 10.5784L16.4124 9.90351C16.8325 9.51337 17.494 9.55566 17.861 9.99612L19.077 11.4553C19.418 11.8645 19.3784 
					12.469 18.9871 12.8303L18.1855 13.5702M15.6855 10.5784L18.1855 13.5702" stroke="var(--defaultIconColor)" strokeWidth="1.37"/>
					<path d="M6.18555 0.685547H2.68555C1.58098 0.685547 0.685547 1.58098 0.685547 2.68555V5.68555M6.18555 0.685547V15.6855M6.18555 
					0.685547H11.6855M6.18555 15.6855H2.68555C1.58098 15.6855 0.685547 14.7901 0.685547 13.6855V10.6855M6.18555 
					15.6855H9.68555M11.6855 0.685547H15.1855C16.2901 0.685547 17.1855 1.58098 17.1855 2.68555V5.68555M11.6855 
					0.685547V9.68555C11.6855 10.2378 11.2378 10.6855 10.6855 10.6855H0.685547M0.685547 10.6855V5.68555M17.1855 
					5.68555H0.685547M17.1855 5.68555V9.18555" stroke="var(--defaultIconColor)" strokeWidth="1.37" strokeLinecap="round"/>
				</svg>
			}
		>
			<EditObstructionOptions>
				<span>Add</span>
				{
					<BtnWrap 
						className='shapeBtn-wrap'
						style={{
							opacity: deleteObstructionsMode ? 0.4 : 1,
							pointerEvents: deleteObstructionsMode ? 'none' : 'auto'
						}}
					>
						<ShapeBtn
							className={`label-orientaion ${OBS_SHAPE.CIRCLE == 'CIRCLE' ? 'CIRCLE' : ''}`}
							id="circle-obs"
							title="Circle"
						>
							<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 22 22" fill="none">
								<circle cx="11" cy="11" r="10" 
									stroke={obstructionShape == OBS_SHAPE.CIRCLE && showAddSelection ? 'var(--primary)' : 'var(--defaultIconColor)'} 
									strokeWidth="1.7"/>
							</svg>
							<input
								type="radio"
								value={OBS_SHAPE.CIRCLE}
								checked={obstructionShape == OBS_SHAPE.CIRCLE && showAddSelection}
								onChange={() => enableAddObsMode(OBS_SHAPE.CIRCLE)}
								disabled={deleteObstructionsMode}
							/>
						</ShapeBtn>
						<ShapeBtn
							className={obstructionShape == OBS_SHAPE.RECT && showAddSelection ? 'RECT' : ''}
							id="rect-obs"
							title="Rectangle"
						>
							<input
								type="radio"
								value={OBS_SHAPE.RECT}
								checked={obstructionShape == OBS_SHAPE.RECT && showAddSelection}
								onChange={() => enableAddObsMode(OBS_SHAPE.RECT)}
								disabled={deleteObstructionsMode}
							/>
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="15.36" viewBox="0 0 25 16" fill="none">
								<path d="M22.5554 1H2.06C1.47458 1 1 1.47458 1 2.06V13.94C1 14.5254 1.47458 15 2.06 15H22.5554C23.1408 
							15 23.6154 14.5254 23.6154 13.94V2.06C23.6154 1.47458 23.1408 1 22.5554 1Z" fill="transparent" 
								stroke={obstructionShape == OBS_SHAPE.RECT && showAddSelection ? 'var(--primary)' : 'var(--defaultIconColor)'} 
								strokeWidth="1.7"/>
							</svg>
						</ShapeBtn>
						<ShapeBtn 
							className={`label-orientaion ${obstructionShape == OBS_SHAPE.POLYGON && showAddSelection ? 'active' : ''}`}
							style={{
								borderRight: 'none',
							}}
							title="Polygon"
							id="polygon-obs">
							<svg xmlns="http://www.w3.org/2000/svg" width="21" height="22.91" viewBox="0 0 24 26" fill="none">
								<path d="M21.3083 8.61406V17.9217M18.9385 5.62012L10.3083 3.23633M7.00203 4.80637L4.07183 
							9.46021M3.53906 13.5417L6.82348 20.8833M10.3083 22.4387L18.7698 20.5722" 
								stroke={obstructionShape == OBS_SHAPE.POLYGON && showAddSelection ? 'var(--primary)' : 'var(--defaultIconColor)'} 
								strokeWidth="1.6" 
								strokeLinejoin="round"
								/>
								<circle cx="8.19351" cy="3.11538" r="2.11538" 
									stroke={obstructionShape == OBS_SHAPE.POLYGON && showAddSelection ? 'var(--primary)' : 'var(--defaultIconColor)'} 
									strokeWidth="1.6"/>
								<circle cx="20.8849" cy="6.4982" r="2.11538" 
									stroke={obstructionShape == OBS_SHAPE.POLYGON && showAddSelection ? 'var(--primary)' : 'var(--defaultIconColor)'} 
									strokeWidth="1.6"/>
								<circle cx="20.8849" cy="20.0373" r="2.11538" 
									stroke={obstructionShape == OBS_SHAPE.POLYGON && showAddSelection ? 'var(--primary)' : 'var(--defaultIconColor)'} 
									strokeWidth="1.6"/>
								<circle cx="8.19351" cy="22.5763" r="2.11538" 
									stroke={obstructionShape == OBS_SHAPE.POLYGON && showAddSelection ? 'var(--primary)' : 'var(--defaultIconColor)'} 
									strokeWidth="1.6"/>
								<circle cx="3.11538" cy="11.5763" r="2.11538" 
									stroke={obstructionShape == OBS_SHAPE.POLYGON && showAddSelection ? 'var(--primary)' : 'var(--defaultIconColor)'} 
									strokeWidth="1.6"/>
							</svg>
							<input
								type="radio"
								value={OBS_SHAPE.POLYGON}
								checked={obstructionShape == OBS_SHAPE.POLYGON && showAddSelection}
								onChange={() => enableAddObsMode(OBS_SHAPE.POLYGON)}
								disabled={deleteObstructionsMode}
							/>
						</ShapeBtn>
					</BtnWrap>
				}
				<span>Delete</span>
				<ModeToggle>
					<div className='switchButton bg-transparent'>
						<div className="toggle-button-cover">
							<div className="button-cover">
								<div className="button b2" id="button-13">
									<input
										type="checkbox"
										className="checkbox"
										onChange={toggleDeleteObsMode}
										checked={deleteObstructionsMode}
									/>
									<div className="knobs">
										<span></span>
									</div>
									<div className="layer"></div>
								</div>
							</div>
						</div>
					</div>
				</ModeToggle>
			</EditObstructionOptions>
			<BtnWrap>
				<UndoButton />
			</BtnWrap>
		</ActionStrip>
	);
}
